import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../redux/actions/authUserActions";
import { AppDispatch } from "../redux/store";
import { useNavigate } from "react-router-dom";
const Logout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logoutUser());
    navigate("/login", { replace: true });
  }, [dispatch, navigate]);
  return <></>;
};
export default Logout;
